import { DisplayTypeState } from './state';
import { DISPLAY_TYPE_CHANGE, DisplayTypeAction } from './types';

const DISPLAY_TYPE_TILE = 'tile';

export function displayTypeReducer(
    displayType: DisplayTypeState = DISPLAY_TYPE_TILE,
    action: DisplayTypeAction
): DisplayTypeState {
    switch (action.type) {
        case DISPLAY_TYPE_CHANGE:
            return action.payload || displayType;
        default:
            return displayType;
    }
}
